// extracted by mini-css-extract-plugin
export var md = "_2p-4";
export var semantic = "_2p-5";
export var sm = "_2p-3";
export var text = "_2p-6";
export var toggleInput = "_2p-0";
export var toggleSwitch = "_2p-1";
export var xs = "_2p-2";